<script setup>
import {inject} from 'vue'
const contentData = inject('contentData')

const props = defineProps({
    data: {
        type: Object,
        required: false,
    },
})
</script>

<template>
    <div class="container px-4 mx-auto">
        <div class="flex flex-wrap items-center justify-center -mx-4 pb-10 sm:pb-16 lg:pb-20">
            <div class="w-full lg:w-1/2 px-4 mb-6 lg:mb-0 flex flex-wrap justify-center items-center">
                <div
                    v-if="contentData.what !== 'rn'"
                    :class="contentData.what === 'rn' ? 'bg-gray-900' : 'bg-red-900'"
                    class="w-full max-w-md rounded-md bg-opacity-60 p-6 backdrop-blur backdrop-filter sm:p-8 lg:max-w-none lg:p-10">
                    <h1 class="font-heading text-3xl text-white sm:text-4xl lg:text-5xl">
                        {{ data.title.content }}
                    </h1>
                    <div class="mt-2 text-base leading-7 text-white sm:text-lg sm:leading-8" v-html="data.subtitle.content"></div>
                </div>

                <div
                    v-if="contentData.what === 'rn'"
                    :class="contentData.what === 'rn' ? 'bg-gray-900' : 'bg-red-900'"
                    class="w-full max-w-md rounded-md bg-opacity-60 p-6 backdrop-blur backdrop-filter sm:p-8 lg:max-w-none lg:p-10">
                    <h1 class="font-heading text-3xl text-white sm:text-4xl lg:text-5xl">
                        {{ contentData.header.title }}
                    </h1>
                    <div class="mt-2 text-base leading-7 text-white sm:text-lg sm:leading-8">{{ contentData.header.text[0] }}</div>
                </div>

                <!--                <div-->
                <!--                    v-if="contentData.what === 'rn'"-->
                <!--                    class="w-full flex flex-wrap justify-around backdrop-blur-3xl backdrop-filter p-4 rounded-lg mt-60">-->
                <!--                    <div class="inline-block">-->
                <!--                        <a-->
                <!--                            href="https://www.snf.ch/en"-->
                <!--                            v-if="contentData.first_logo !== '../assets/rn/SNF_logo.png'">-->
                <!--                            <img src="../assets/banner.png" alt="The logo image of ETHZ" />-->
                <!--                        </a>-->
                <!--                    </div>-->
                <!--                </div>-->

                <div v-if="contentData.what !== 'rn'" class="w-full flex justify-center mt-12">
                    <!--                    <a-->
                    <!--                        class="inline-flex items-center justify-center bg-red-900 px-10 py-3 font-heading font-semibold text-base text-white rounded-full border border-white/50 shadow-md hover:bg-red-800 hover:shadow-lg transition duration-200"-->
                    <!--                        href="https://ethzurich.eventsair.com/pht26/regi">-->
                    <!--                        Register-->
                    <!--                    </a>-->
                </div>
            </div>
        </div>
    </div>
</template>
